import React, { useEffect,useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';

const AddLeadSts = ({ show, onClose, refresh }) => {
    const [leadstatus_name, setname] = useState('');
    const [description, setDescription] = useState('');
    const [error, setError] = useState('');
    const [existingLeadstatus, setExistingLeadstatus] = useState([]);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [backgroundColor, setBackgroundColor] = useState('#000000');
    const [textColor, setTextColor] = useState('#ffffff');
    // const [colorChange] = useState(null);

    useEffect(() => {
        if (show) {
            axios.get(`${baseURL}/leadstatus`) 
                .then(response => {
                    setExistingLeadstatus(response.data.data.data.map(leadstatus => leadstatus.leadstatus_name.toLowerCase()));
                })
                .catch(error => {
                    console.error("Error fetching leadstatus", error);
                });
        }
    }, [show]);

    const formatleadstatusName = (name) => {
        return name.charAt(0).toUpperCase() + name.slice(1);
    };

    const validateInput = () => {
        // Check if the lead status name is empty
        if (!leadstatus_name.trim()) {
            setError("leadstatus is required.");
            return false;
        }
        
        const regex = /^[A-Za-z\s]+$/;
        if (!regex.test(leadstatus_name)) {
            setError("Only text is valid.");
            return false;
        }

        // Check if the leadstatus already exists
        if (existingLeadstatus.includes(leadstatus_name.trim().toLowerCase())) {
            setError("leadstatus already exists.");
            return false;
        }

        setError('');
        return true;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const formattedleadstatusName = formatleadstatusName(leadstatus_name);
        // Run validation before submitting
        if (!validateInput()) return;

        const postData = { 
            leadstatus_name: formattedleadstatusName,
            description: description.trim() || "-" ,
            background_color: backgroundColor,  // <-- new state variable
            text_color: textColor
         };
        

        // Send the request to the backend
        axios.post(`${baseURL}/leadstatus`, postData)
            .then(response => {
                refresh();
                onClose();
                toast.success("Lead Status Created successfully!");
                // window.location.reload(); // Optionally update the UI with new data
            })
            .catch(error => {
                setError("An error occurred while creating the lead status.");
                console.error("Error:", error);
            });
    };

    return (
        <Modal show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Create Lead Status</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className='text-white'>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Lead Status<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Lead Status" 
                            value={leadstatus_name} 
                            onChange={(e) => setname(formatleadstatusName(e.target.value))} />
                            {error && <small className="text-danger">{error}</small>}
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Background Color<span className="required">*</span></label>
                            <input type="color" className="form-control"  placeholder="Choose Background Color"
                            value={backgroundColor}
                            onChange={(e) => setBackgroundColor(e.target.value)}
                           />
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Text Color<span className="required">*</span></label>
                            <input type="color" className="form-control"  placeholder="Choose Text Color" value={textColor}
                            onChange={(e) => setTextColor(e.target.value)}/>
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea rows={8} className="form-control" name="comment" placeholder="Description" value={description}
                            onChange={(e) => setDescription(e.target.value)}  />
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        {/* <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link> */}
                        <button type="submit" className="btn btn-sm btn-primary" >Create Lead Status<i className="fas fa-angle-double-right ms-2"></i></button>
                    </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
};

export default AddLeadSts;
